import { Avatar, styled } from '@mui/material';

export const StyledAvatar = styled(Avatar)(({ theme }) => ({
    height: '80px',
    width: '80px',
    [theme.breakpoints.up('xxl')]: {
        height: '100px',
        width: '100px',
    },
}));
